<template>
  <div id="page-mediaSpec">
    <Row class="main" :gutter="16">
      <Col span="5">
        <myaside
          ref="asideBar"
          @handleSelectTask="handleSelectTask"
        ></myaside>
      </Col>
      <Col span="19" id="rightSide">
        <!-- 过滤按钮----------------------------------------------------------------------------->
        <div class="content-up">
          <!-- 发布时间 ----------------------------------------------------------->
          <Row>
            <Col span="3" style="text-align: right">
              <span class="option-title">发布时间</span>
            </Col>
            <Col span="21">
              <ul class="buttonGroup buttonGroup-date">
                <li
                  class="btn-item btn-item-1d btn-active"
                  @click="handleSelectLanchDate('1d')"
                >今天</li>
                <li
                  class="btn-item btn-item-3d"
                  @click="handleSelectLanchDate('3d')"
                >近3天</li>
                <li
                  class="btn-item btn-item-7d"
                  @click="handleSelectLanchDate('7d')"
                >近7天</li>
                <li
                  class="btn-item btn-item-30d"
                  @click="handleSelectLanchDate('30d')"
                >近30天</li>
                <li
                  class="btn-item btn-item-custom"
                  @click="setLanchDateByCustom('custom')"
                >自定义</li>
              </ul>
              <DatePicker
                type="daterange"
                @on-ok="confirmDatePicker"
                v-model="dateRange"
                placement="bottom-end"
                placeholder="请选择日期范围"
                style="width: 200px; margin-top:5px"
                confirm
                class="datePicker"
                v-show="isShowDatePicker"
                split-panels
              ></DatePicker>
            </Col>
          </Row>
          <!-- 情感分类 ----------------------------------------------------------->
          <Row style="margin-top:23px">
            <Col span="3" style="text-align: right">
              <span class="option-title">情感分类</span>
            </Col>
            <Col span="21">
              <ul class="buttonGroup buttonGroup-sentiment">
                <li
                  class="btn-item"
                  :class="[{'btn-active':queryData.feeling==3}]"
                  @click="handleSelectSentiment(3)"
                >全部</li>
                <li
                  class="btn-item"
                  :class="{'btn-active':queryData.feeling==1}"
                  @click="handleSelectSentiment(1)"
                >负面</li>
                <li
                  class="btn-item"
                  :class="[{'btn-active':queryData.feeling==0},{'btn-disabled':queryData.sourceType == '投诉'}]"
                  @click="handleSelectSentiment(0)"
                >中性</li>
                <li
                  class="btn-item"
                  :class="[{'btn-active':queryData.feeling==2},{'btn-disabled':queryData.sourceType == '投诉'}]"
                  @click="handleSelectSentiment(2)"
                >正面</li>
              </ul>
            </Col>
          </Row>
          <!-- 来源分类 ----------------------------------------------------------->
          <Row style="margin-top:23px">
            <Col span="3" style="text-align: right">
              <span class="option-title">来源分类</span>
            </Col>
            <Col span="21">
              <ul class="buttonGroup buttonGroup-origin">
                <li
                  class="btn-item"
                  :class="{'btn-active':queryData.sourceType==''}"
                  @click="handleSelectOrigin('allOrigin')"
                >全部</li>
                <li
                  class="btn-item"
                  :class="{'btn-active':queryData.sourceType.indexOf('新闻') != -1}"
                  @click="handleSelectOrigin('新闻')"
                >新闻</li>
                <li
                  class="btn-item"
                  :class="{'btn-active':queryData.sourceType.indexOf('微博') != -1}"
                  @click="handleSelectOrigin('微博')"
                >微博</li>
                <li
                  class="btn-item"
                  :class="{'btn-active':queryData.sourceType.indexOf('公众号') != -1}"
                  @click="handleSelectOrigin('公众号')"
                >公众号</li>
                <li
                  class="btn-item"
                  :class="{'btn-active':queryData.sourceType.indexOf('贴吧') != -1}"
                  @click="handleSelectOrigin('贴吧')"
                >贴吧</li>
                <li
                  class="btn-item"
                  :class="{'btn-active':queryData.sourceType=='投诉'}"
                  @click="handleSelectOrigin('投诉')"
                >投诉</li>
              </ul>
            </Col>
          </Row>
          <!-- 自定义分类 ----------------------------------------------------------->
          <Row style="margin-top:23px">
            <Col span="3" style="text-align: right">
              <span class="option-title">自定义分类</span>
            </Col>
            <Col span="21">
              <ul class="buttonGroup buttonGroup-custom">
                <li
                  class="btn-item btn-item-allCustom"
                  :class="{'btn-active':queryData.customClassifyName==''}"
                  @click="handleSelectCustom('')"
                >全部</li>
                <li
                  class="btn-item"
                  :class="{'btn-active':customClassifyNameList.indexOf(u) != -1}"
                  v-for="(u,i) in btnTab_customClassifyName"
                  :key="i"
                  @click="handleSelectCustom(u)"
                >{{u}}</li>
              </ul>
            </Col>
          </Row>
          <!-- 排序分类 ----------------------------------------------------------->
          <Row style="margin-top:23px">
            <Col span="3" style="text-align: right">
              <span class="option-title">排序方式</span>
            </Col>
            <Col span="21">
              <ul class="buttonGroup buttonGroup-sort">
                <li
                  class="btn-item"
                  :class="{'btn-active':queryData.sortType == 'desc'}"
                  @click="handleSelectSort('desc')"
                >时间降序</li>
                <li
                  class="btn-item"
                  :class="{'btn-active':queryData.sortType == 'asc'}"
                  @click="handleSelectSort('asc')"
                >时间升序</li>
                <li
                  class="btn-item"
                  :class="{'btn-disabled':!isSimilarArticlesClickable || queryData.sourceType=='投诉','btn-active':queryData.sortType == 'similar'}"
                  @click="handleSelectSort('similar')"
                >相似文章</li>
              </ul>
            </Col>
          </Row>
          <!-- 相似文章 ----------------------------------------------------------->
          <Row style="margin-top:23px">
            <Col span="3" style="text-align: right">
              <span class="option-title">相似文章</span>
            </Col>
            <Col span="21">
              <ul class="buttonGroup buttonGroup-article">
                <li
                  class="btn-item"
                  :class="{'btn-active':queryData.isRepeat==0 && queryData.sourceType != '投诉', 'btn-disabled':queryData.sourceType == '投诉'}"
                  @click="handleSelectArticle(0)"
                >去重</li>
                <li
                  class="btn-item"
                  :class="{'btn-disabled':!isRepeatClickable || queryData.sourceType=='投诉','btn-active':queryData.isRepeat==1}"
                  @click="handleSelectArticle(1)"
                >不去重</li>
              </ul>
            </Col>
          </Row>
          <!-- 预警分类---------------------------------------------------------->
          <Row style="margin-top:23px">
            <Col span="3" style="text-align: right">
              <span class="option-title">预警分类</span>
            </Col>
            <Col span="21">
              <ul class="buttonGroup buttonGroup-article">
                <li
                    class="btn-item"
                    :class="{'btn-active':queryData.isWarn===1?true:false}"
                    @click="handleSelectIsWarn(1)"
                >全部</li>
                <li
                    class="btn-item"
                    :class="{'btn-active':queryData.isWarn===0?true:false}"
                    @click="handleSelectIsWarn(0)"
                >预警</li>
              </ul>
            </Col>
          </Row>
          <!-- 关键词 ----------------------------------------------------------->
          <Row style="margin-top:23px">
            <Col span="3" style="text-align: right">
              <span class="option-title">关键词</span>
            </Col>
            <Col span="21">
              <Input
                v-model="search_keywords"
                search
                @on-search="searchByKeywords"
                icon="ios-search-outline"
                placeholder="结果内搜索"
                style="width: 318px"
                class="input-search"
              />
            </Col>
          </Row>
        </div>
        <div class="content-down" ref="content_down">
          <div class="tab-header" :class="{'tab-header-stick':isTabHeaderStick}">
            <span
              class="tab-title"
              :class="{'tab-title-selected':isShowContentMsgList&&enable_list,'disabled':!enable_list}"
              @click="changeView(0)"
            >舆情列表</span>
            <span
              class="tab-title"
              :class="{'tab-title-selected':!isShowContentMsgList&&enable_analyze,'disabled':!enable_analyze}"
              @click="changeView(1)"
            >快速分析</span>
            <div class="dataNum-wrapper">
              <span
                class="tag-dataNum"
                :class="{'btn-active':queryData.isExcludeWord==true, 'btn-active':queryData.isExcludeWord==false }"
                style="background-color:#999999"
                :style="{'background-color':queryData.isExcludeWord==true?'#415af6':'#999999'}"
                @click="handleExcludeWords()"
              >
              过滤排除词
              </span>
              <Tag color="black" class="tag-dataNum">总量：{{dataNum_total}}</Tag>
              <Tag color="success" class="tag-dataNum">正面：{{dataNum_positive}}</Tag>
              <Tag color="warning" class="tag-dataNum">中性：{{dataNum_middle}}</Tag>
              <Tag color="error" class="tag-dataNum">负面：{{dataNum_negative}}</Tag>
              <Tag color="#BD10E0" class="tag-dataNum">预警：{{dataNum_warning}}</Tag>
            </div>
          </div>
          <div
            class="tab-header-placeholder"
            :class="{'tab-header-placeholder-active':isTabHeaderStick}"
          ></div>
          <!-- 舆情列表----------------------------------------------------------------------------->
          <div class="tab-main tab-main-msgList" v-show="isShowContentMsgList">
            <div class="tab-content">
              <div class="tip" v-show="isShowTip" @click="handleClickTip">
                <p>截止到{{tip.currentDate}} {{tip.currentTime}}，又抓取到{{tip.newDataNum}}条新数据，点击刷新数据列表</p>
              </div>
              <div class="listMessage-wrapper">
                <ul class="listMessage">
                  <li class="listMessage-item" v-for="item in listMessage" :key="item.id">
                    <div class="ls">
                      <Tag
                        :color="item.tagColor"
                        class="tag-property"
                        style="width:56px"
                      >{{item.tagLabel}}</Tag>
                    </div>
                    <div class="rs">
                      <div class="rs-main" @click="gotoSource(item.sourceUrl,item.urlid,item.update_time,item)">
                        <div class="message-title">
                          <div class="message-link-toSpecGroup" style="display: inline-block">
                            <span class="groupMemberName">{{item.title}}</span>
                          </div>
                          <span class="icon-warning" v-if="item.isWarn==='1'"></span>
                          <span class="messageLanchTime">{{item.date}} {{item.time}}</span>
                        </div>
                        <div class="message-content" v-html="item.content"></div>
                      </div>
                      <div class="message-footer-news message-footer" v-if="item.search_type==='新闻'">
                        <div class="message-footer-ls">
                          <div class="footer-item">
                            关键词：
                            <span v-html="item.search_words"></span>
                          </div>
                          <div class="footer-item">
                            词频：
                            <span v-html="item.frequency"></span>
                          </div>
                          <div class="footer-item">
                            来源：
                            <span>{{item.source_name}}</span>
                          </div>
                        </div>
                        <div class="message-footer-rs">
                          <div
                            class="similarArticle"
                            @click="checkSimilarArticle([item.uniqueId,item.id,item.similarTxtNum ])"
                            v-show="isRepeat"
                          >相似文章: {{item.similarTxtNum }}</div>
                        </div>
                      </div>
                      <div class="message-footer-weibo message-footer" v-if="item.search_type==='微博'">
                        <div class="message-footer-ls">
                          <div class="footer-item">
                            粉丝数：
                            <span>{{item.followers_num}}</span>
                          </div>
                          <div class="footer-item">
                            评论量：
                            <span>{{item.comment_num}}</span>
                          </div>
                          <div class="footer-item">
                            点赞量：
                            <span>{{item.like_num}}</span>
                          </div>
                          <div class="footer-item">
                            转发量：
                            <span>{{item.forward_num}}</span>
                          </div>
                        </div>
                        <div class="message-footer-rs">
                          <div
                            class="similarArticle"
                            @click="checkSimilarArticle([item.uniqueId,item.id,item.similarTxtNum ])"
                            v-show="isRepeat"
                          >相似微博: {{item.similarTxtNum }}</div>
                        </div>
                      </div>
                      <div class="message-footer-pubilc message-footer" v-if="item.search_type==='公众号'">
                        <div class="message-footer-ls">
                          <div class="footer-item">
                            公众号：
                            <span>{{item.source_name}}</span>
                          </div>
                          <div class="footer-item">
                            词频：
                            <span v-html="item.frequency"></span>
                          </div>
                          <div class="footer-item">
                            作者：
                            <span>{{item.author}}</span>
                          </div>
                        </div>
                        <div class="message-footer-rs">
                          <div
                            class="similarArticle"
                            @click="checkSimilarArticle([item.uniqueId,item.id,item.similarTxtNum ])"
                            v-show="isRepeat"
                          >相似文章: {{item.similarTxtNum }}</div>
                        </div>
                      </div>
                      <div class="message-footer-tieba message-footer" v-if="item.search_type==='贴吧'">
                        <div class="footer-item">
                          发帖人：
                          <span>{{item.author}}</span>
                        </div>
                        <div class="footer-item">
                          楼层总数：
                          <span>{{item.floor_count}}</span>
                        </div>
                      </div>
                      <div class="message-footer-tousu message-footer" v-if="item.search_type === '投诉'">
                        <div class="footer-item rele" @mouseenter ="hoverFooterItem($event,item.target)" @mouseleave="leaveFooterItem">投诉对象：<span>{{item.target}}</span></div>
                        <div class="footer-item" @mouseenter="hoverFooterItem($event,item.problem_type)" @mouseleave="leaveFooterItem">投诉问题：<span>{{item.problem_type}}</span></div>
                        <div class="footer-item" @mouseenter="hoverFooterItem($event,item.appeal_type)" @mouseleave="leaveFooterItem">投诉要求：<span>{{item.appeal_type}}</span></div>
                        <div class="footer-item rele">是否关联集体投诉：<span>{{item.type == 0 ? '否':'是'}}</span></div>
                        <!-- <div class="footer-item">发布时间：<span>{{item.date}}</span></div> -->
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="page-wrapper" v-show="isShowPage">
              <Page
                :total="listMessage_totalNum"
                :current="currentPage"
                @on-change="changePage"
                show-total
                class="page"
              />
            </div>
          </div>
          <!-- 快速分析----------------------------------------------------------------------------->
          <div class="tab-main tab-main-rapidAnalyse" v-show="!isShowContentMsgList">
            <div class="tip" v-show="isShowTip" @click="handleClickTip">
              <p>截止到{{tip.currentDate}} {{tip.currentTime}}，又抓取到{{tip.newDataNum}}条新数据，点击刷新数据列表</p>
            </div>
            <div class="wrap-up">
              <!-- 舆情走势 -------------------------------------------------------->
              <section class="wrap-trendCharts">
                <h2 class="section-title">舆情走势</h2>
                <span class="icon-download" @click="downLoadTrendPic">下载</span>
                <loading-icon :isShowLoadingIcon="isBtnDownloadDisabled_trend"></loading-icon>
                <ul class="btnGroup">
                  <li
                    class="btnItem"
                    :class="{'isSelected':btnTrendIsActive.all}"
                    @click="handleSelectBtnTrend('all')"
                  >全部</li>
                  <li
                    v-if="queryData.sourceType !== '投诉'"
                    class="btnItem"
                    :class="{'isSelected':btnTrendIsActive.source}"
                    @click="handleSelectBtnTrend('source')"
                  >来源分类</li>
                  <li
                    v-if="queryData.sourceType !== '投诉'"
                    class="btnItem"
                    :class="{'isSelected':btnTrendIsActive.emotions}"
                    @click="handleSelectBtnTrend('emotions')"
                  >情感分类</li>
                </ul>
                <div class="charts-wrapper">
                  <div
                    ref="charts_line_total"
                    class="charts_line_total"
                    v-show="btnTrendIsActive.all"
                  ></div>
                  <div
                    ref="charts_line_source"
                    class="charts_line_source"
                    v-show="btnTrendIsActive.source"
                  ></div>
                  <div
                    ref="charts_line_emotions"
                    class="charts_line_emotions"
                    v-show="btnTrendIsActive.emotions"
                  ></div>
                </div>
              </section>
              <!-- 媒体预警量排行 -------------------------------------------------------->
              <section class="wrap-mediaSpecTable">
                <h2 class="section-title">媒体预警量排行</h2>
                <table cellspacing="0" cellpadding="0" border="0" class="table">
                  <thead class="table-head">
                    <tr align="center">
                      <th>媒体</th>
                      <th>预警量</th>
                      <th>总量</th>
                      <th>预警比例</th>
                    </tr>
                  </thead>
                  <tbody class="table-body">
                    <tr v-for="(item,i) in table_mediaSpecData" :key="i">
                      <td>{{item.name}}</td>
                      <td>{{item.alertAmount}}</td>
                      <td>{{item.total}}</td>
                      <td>{{item.alertRatio}}</td>
                    </tr>
                    <tr v-if="table_mediaSpecData.length == 0">
                      <td colspan=4 style="text-align:center">暂无数据</td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
            <div class="wrap-down">
              <!-- 情感分布 -------------------------------------------------------->
              <div class="wrap-emotionsDistribution">
                <h2 class="section-title">情感分布</h2>
                <span class="icon-download" @click="downLoadEmotionsPic">下载</span>
                <loading-icon :isShowLoadingIcon="isBtnDownloadDisabled_emotions"></loading-icon>
                <div class="charts-wrapper">
                  <div ref="charts_circle" class="charts_circle"></div>
                </div>
              </div>
              <!-- 词云分析 -------------------------------------------------------->
              <section class="wrap-wordCloudCharts">
                <h2 class="section-title">词云分析</h2>
                <span class="icon-download" @click="downLoadWordCloudPic">下载</span>
                <loading-icon :isShowLoadingIcon="isBtnDownloadDisabled_wordCloud"></loading-icon>
                <div class="charts-wrapper">
                  <div ref="charts_wordCloud" class="charts_wordCloud"></div>
                </div>
                <footer class="wordCloud-footer">
                  <span class="wordCloud-legend legend-positive">正面</span>
                  <span class="wordCloud-legend legend-middle">中性</span>
                  <span class="wordCloud-legend legend-negative">负面</span>
                </footer>
              </section>
            </div>
          </div>
        </div>
      </Col>
    </Row>
    <!-- loading动画 --------------------------------------------------------------------------->
    <loading
      :isLoading="isLoading_statistics||isLoading_listMessage||isLoading_rapidAnalyse_wordCloud"
    ></loading>
    <div class="hover-text" :style="{top:hoverTextTop, left:hoverTextLeft}" v-if="hoverTextShow">{{hoverText}}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //公共+舆情列表数据------------------------------------------------------------------------//
      //是否展示舆情列表/快速分析
      isShowContentMsgList: true,
      //tabHeader是否吸顶
      isTabHeaderStick: false,
      //当前所选任务id
      currentTaskId: "",
      //任务列表数据
      taskList: [],
      //过滤后的任务列表数据
      taskList_search: [],
      //控制统计数据的加载
      isLoading_statistics: false,
      //传给按照条件查询的数据
      queryData: {
        jobId: "", //任务唯一Id
        startTimeMs: new Date().setHours(0, 0, 0, 0), //发布时间（起始）（毫秒）
        endTimeMs: new Date().getTime(), //发布时间（终止）（毫秒）
        feeling: null, //情感分类：0:中性 1:负面  2:正面  3:全部
        sourceType: "", //来源分类名称：空代表全部
        customClassifyName: "", //自定义分类名称：空代表全部
        sortType: "", //排序方式：asc：升序；desc：降序；similar：相似文章排序
        isRepeat: null, //去重选项：0：去重；1：不去重
        searchWord: "", //结果内搜索的搜索词，空代表没有，所有输入当一个词匹配
        pageNum: 1, //页码
        pageSize: 10, //页面大小
        isExcludeWord: false, // 是否去除排除词
        isWarn: 1
      },
      //自定义分类列表
      customClassifyNameList:[],
      //控制datePiker的显示
      isShowDatePicker: false,
      //datePicker绑定的值
      dateRange: [],
      //来源分类按钮上各个来源的数目
      sourceNum: {
        all: 0,
        news: 0,
        weibo: 0,
        public: 0
      },
      //自定义分类按钮
      btnTab_customClassifyName: [],
      //<排序方式>按钮中<相似文章>是否可点击
      isSimilarArticlesClickable: true,
      //<详细文章>按钮中<不去重>是否可点击
      isRepeatClickable: true,
      //<关键词>搜索框绑定数据
      search_keywords: "",
      //统计数据tag--总量
      dataNum_total: null,
      //统计数据tag--正面
      dataNum_positive: null,
      //统计数据tag--中性
      dataNum_middle: null,
      //统计数据tag--负面
      dataNum_negative: null,
      //统计数据tag--预警
      dataNum_warning: null,
      //控制tip的显示
      isShowTip: false,
      //tip的数据
      tip: {
        currentDate: "",
        currentTime: "",
        newDataNum: 0
      },
      //控制消息列表<相似文章>的展示
      isRepeat: true,
      //控制舆情列表的加载
      isLoading_listMessage: false,
      //舆情列表的数据
      listMessage: [
        // {
        //   id: "1",
        //   uniqueId: "666", //不是唯一id，用于相似文章
        //   tagColor: "error",
        //   tagLabel: "负面",
        //   title: "团贷网人生如梦(3117457348)   QQ群：2819782781",
        //   sourceUrl: "https://www.baidu.com",
        //   content:
        //     "平凡阿非说的非常好，对王岩这种阴险狡诈卑劣小人，立案是唯一行之有效的措施，立案能回来多少钱没人能知道，就知道不立案也没钱回来，至于团贷网头目为什么还有那么多可周转资金就投案自首了，说明他没有后台怕枪毙，王岩为什么不自首还一直牵着所有出借人的鼻子走，兑了二百多元海淀经侦就认可说有诚意，说明他有后台撑腰，不会被枪毙",
        //   //发布者
        //   origin: "新浪财经",
        //   //发布日期
        //   date: "2019-03-30",
        //   //发布时间
        //   time: "19:01",
        //   //关键词
        //   keywords: "团贷网 贷款",
        //   //词频
        //   frequency: "团贷网(20) 立案(5)",
        //   //相似文章数量
        //   articleNum: 291,
        //   //文章来源
        //   source_name: '新闻',
        //   //是否预警
        //   isWarn: '1',
        //   //如果是微博---------------------------------------------------------------//
        //   //粉丝数
        //   followers_num: 222,
        //   //评论量
        //   comment_num: 666,
        //   //点赞量
        //   like_num: 777,
        //   //转发量
        //   forward_num: 999,
        //   //如果是公众号---------------------------------------------------------------//
        //   author: '老王'
        // }
      ],
      //舆情列表的总数
      listMessage_totalNum: 1,
      //当前页码
      currentPage: 1,
      //记录上次刷新列表的时间
      lastRefreshTime: -1,
      //tip的定时器
      timer: null,
      //tip数据更新的loading
      isLoading_tipInfo: false,
      //任务列表搜索输入框防抖timer
      timer_taskList: null,
      //是否具有舆情列表查看权限
      enable_list: false,
      //快速分析数据------------------------------------------------------------------------//
      //是否具有快速分析查看权限
      enable_analyze: false,
      //控制快速分析模块数据加载(词云分析除外)
      isLoading_rapidAnalyse: false,
      //控制快速分析模块数据加载--词云分析
      isLoading_rapidAnalyse_wordCloud: false,
      //控制<舆情走势>的tab按钮
      btnTrendIsActive: {
        all: true,
        source: false,
        emotions: false
      },
      //记录每一个图表的dataUrl
      echartsDataUrl: {
        url_trend_all: "", //舆情走势--全部
        url_trend_source: "", //舆情走势--来源分类
        url_trend_emotions: "", //舆情走势--情感分类
        url_wordCloud: "" //词云分析
      },
      //<舆情走势>的下载按钮是否禁用
      isBtnDownloadDisabled_trend: true,
      //<情感分布>的下载按钮是否禁用
      isBtnDownloadDisabled_emotions: true,
      //<词云分析>的下载按钮是否禁用
      isBtnDownloadDisabled_wordCloud: true,
      //<舆情走势>模块数据
      sentimentTrendData: {
        xData: [],
        charts_all: [],
        charts_source: {
          data_legend: [],
          data_y: []
        },
        charts_emotion: {
          data_legend: [],
          data_y: []
        }
      },
      //<情感分布>模块数据
      emotionsDistrubutionData: [],
      //<词云分析>模块数据
      wordCloudData: [],
      //<媒体预警量排行>表格数据
      table_mediaSpecData: [],
      //如果消息数目为0，则不显示分页
      isShowPage: true,
      hoverTextShow:false,
      hoverText :'',
      hoverTextTop:0,
      hoverTextLeft:0
    };
  },
  mounted() {
    //为侧边栏添加吸顶效果
    this.tabHeaderStickToTop();
    //获取舆情列表和快速分析权限
    this.getAuthorities();
  },
  destroyed() {
    //销毁vm实例后，解除滚动绑定事件
    this.removeScrollEvent();
  },
  methods: {
    //公共+舆情列表模块------------------------------------------------------------------//
    //获取舆情列表和快速分析权限
    getAuthorities(){
      let authorites = this.getLocalStorage('authorities').split(',');
      this.enable_list = authorites.includes('media_list');
      this.enable_analyze = authorites.includes('media_analyze');
    },
    //切换舆情列表和快速分析视图
    changeView(param){
      if(param===0){
        //舆情列表
        if(this.enable_list){
          this.isShowContentMsgList = true;
        }else{
          this.$Message.error('未获得该模块权限');
        }
      }else{
        //快速分析
        if(this.enable_analyze){
          this.isShowContentMsgList = false;
        }else{
          this.$Message.error('未获得该模块权限');
        }
      }
    },
    //为aside添加吸顶功能
    tabHeaderStickToTop() {
      this.$nextTick(() => {
        window.addEventListener("scroll", this.addScrollEvent, false);
      });
    },
    //给window绑定滚动事件
    addScrollEvent(e) {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
        //令tabHeader吸顶
        if (scrollTop > 580) {
          this.isTabHeaderStick = true;
        } else {
          this.isTabHeaderStick = false;
        }
    },
    //给window解除滚动事件
    removeScrollEvent() {
      window.removeEventListener("scroll", this.addScrollEvent);
    },
    //点击<任务列表>中的项
    handleSelectTask(id) {
      //更新当前所选任务id和查询条件的任务id
      this.currentTaskId = this.queryData.jobId = id;
      //获取该任务列表下的统计信息
      this.getStatistics();
    },
    //获取某个任务下的数据统计信息，刷新过滤tab按钮
    getStatistics() {
      if (this.isLoading_statistics) return;
      this.isLoading_statistics = true;
      //当前任务id不能为空
      if (!this.currentTaskId) {
        this.isLoading_statistics = false;
        return;
      }
      this.$ajax({
        method: "get",
        url: "./sentiment/longTxtData/longTxtsAnalysis",
        params: {
          jobId: this.currentTaskId,
          startTimeMs: this.queryData.startTimeMs,
          endTimeMs: this.queryData.endTimeMs
        }
      })
        .then(res => {
          this.isLoading_statistics = false;
          if (res.data.success) {
            let resData = res.data.data;
            //获取按钮数据成功后，先还原所有按钮默认选项，然后恢复页码
            this.initAll();
            //更新<自定义分类>按钮样式
            this.btnTab_customClassifyName = [...resData.customClassifyName];
            //更新<来源分类>按钮样式
            for (let i = 0; i < resData.sourceAggs.length; i++) {
              if (resData.sourceAggs[i].key === "微博") {
                this.sourceNum.weibo = resData.sourceAggs[i].count;
              } else if (resData.sourceAggs[i].key === "新闻") {
                this.sourceNum.news = resData.sourceAggs[i].count;
              } else if (resData.sourceAggs[i].key === "公众号") {
                this.sourceNum.public = resData.sourceAggs[i].count;
              }
            }
            this.sourceNum.all =
              this.sourceNum.news +
              this.sourceNum.weibo +
              this.sourceNum.public;
            //根据条件获取舆情列表数据
            this.getMessageListInfo();
            //根据条件获取快速分析模块数据(词云分析除外)
            this.getRapidAnalyseInfo();
            //根据当前查询条件查询快速分析模块数据--词云
            this.getRapidAnalyseInfo_wordCloud();
          } else {
            if (res.data.code !== 405) {
              //this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          //this.$Message.error("服务器错误");
          this.isLoading_statistics = false;
          console.log(err);
        });
    },
    //投诉问题等过长 hover显示
    hoverFooterItem(e,str){
      let that = this
      that.hoverText = str
      that.hoverTextShow = true;
      that.hoverTextTop = e.clientY + 'px'
      that.hoverTextLeft = e.clientX + 'px'
    },
    leaveFooterItem(){
      let that = this
      that.hoverTextShow = false
    },
    //根据过滤条件获取舆情列表的数据
    getMessageListInfo(isFromTip = false) {
      if (this.isLoading_listMessage) return;
      this.isLoading_listMessage = true;
      //jobId不能为空
      if (this.queryData.jobId === "") {
        this.isLoading_listMessage = false;
        return;
      }
      //如果点击了tip，则需要更新queryData.endTimeMs为点击tip的时间
      if (isFromTip) {
        this.queryData.endTimeMs = new Date().getTime();
      }
      this.$ajax({
        method: "get",
        url: "./sentiment/longTxtData/longTxtsList",
        params: this.queryData
      })
        .then(res => {
          this.isLoading_listMessage = false;
          if (res.data.success) {
            //先清空listMessage
            this.listMessage = [];

            let resData = res.data.data || {};
            this.dataNum_total = resData.total || 0;
            //如果是<去重>，则取返回数据的removeRepeatTotal字段，否则取total字段
            if(this.queryData.sourceType == '投诉'){
              this.listMessage_totalNum = resData.total
            }else if(this.queryData.isRepeat === 0){
              this.listMessage_totalNum = resData.removeRepeatTotal
            }else{
              this.listMessage_totalNum = resData.total
            }
            // this.listMessage_totalNum =
            //   this.queryData.isRepeat === 0
            //     ? resData.removeRepeatTotal
            //     : resData.total;
            this.dataNum_positive = resData.positiveNum || 0;
            this.dataNum_middle = resData.neutralityNum || 0;
            this.dataNum_negative = resData.negativeNum || 0;
            this.dataNum_warning = resData.warningNum || 0;
            let listInfo = resData.detail || [];
            //如果消息数目为0，则隐藏页码
            this.isShowPage = listInfo.length > 0 ? true : false;

            this.listMessage = listInfo;
            this.listMessage.forEach((item,index) => {
              this.listMessage[index].tagColor = (function(feeling) {
                  let tagColor = "warning";
                  switch (feeling) {
                    case "0":
                      //中性
                      tagColor = "warning";
                      break;
                    case "1":
                      //负面
                      tagColor = "error";
                      break;
                    case "2":
                      //正面
                      tagColor = "success";
                      break;
                    default:
                      break;
                  }
                  return tagColor;
                })(item.feeling);
                this.listMessage[index].tagLabel = (function(feeling){
                  let tagLabel = "中性";
                  switch (feeling) {
                    case "0":
                      //中性
                      tagLabel = "中性";
                      break;
                    case "1":
                      //负面
                      tagLabel = "负面";
                      break;
                    case "2":
                      //正面
                      tagLabel = "正面";
                      break;
                    default:
                      break;
                  }
                  return tagLabel;
                })(item.feeling)

                if(item.search_type == "微博"){
                  this.listMessage[index].title = item.author
                }else if(item.search_type == "贴吧"){
                  this.listMessage[index].title = `[${item.bar_name}吧] ${item.title}`
                }
                this.listMessage[index].content = item.outline.length > 80 ? item.outline.substring(0, 80) + "..." : item.outline;
                this.listMessage[index].date = this.formatDate(parseInt(item.publishTime));
                this.listMessage[index].time = this.formatTime(parseInt(item.publishTime));

                this.listMessage[index].frequency = (function(keyword_match) {
                  let frequency = "";
                  //先删除所有count为0的数组
                  keyword_match = keyword_match.filter(item => {
                    return item.count > 0;
                  });
                  //然后对剩余数组进行排序
                  let arr_frequency = keyword_match
                    .sort((a, b) => b.count - a.count)
                    .slice(0, 2);
                  if (arr_frequency.length === 2) {
                    frequency = `${arr_frequency[0].keyword}(${arr_frequency[0].count})&nbsp;&nbsp;${arr_frequency[1].keyword}(${arr_frequency[1].count})`;
                  } else if (arr_frequency.length === 1) {
                    frequency = `${keyword_match[0].keyword}(${keyword_match[0].count})`;
                  }
                  return frequency;
                })(item.keyword_match ? item.keyword_match : [])
            })
            
            console.log(this.listMessage)
            
            // listInfo.forEach(item => {
            //   this.listMessage.push({
            //     id: item.id,
            //     uniqueId: item.uniqueId,
            //     tagColor: (function(feeling) {
            //       let tagColor = "error";
            //       switch (feeling) {
            //         case "0":
            //           //中性
            //           tagColor = "warning";
            //           break;
            //         case "1":
            //           //负面
            //           tagColor = "error";
            //           break;
            //         case "2":
            //           //正面
            //           tagColor = "success";
            //           break;
            //         default:
            //           break;
            //       }
            //       return tagColor;
            //     })(item.feeling),
            //     tagLabel: (function(feeling) {
            //       let tagLabel = "error";
            //       switch (feeling) {
            //         case "0":
            //           //中性
            //           tagLabel = "中性";
            //           break;
            //         case "1":
            //           //负面
            //           tagLabel = "负面";
            //           break;
            //         case "2":
            //           //正面
            //           tagLabel = "正面";
            //           break;
            //         default:
            //           break;
            //       }
            //       return tagLabel;
            //     })(item.feeling),
            //     title: (function(item) {
            //       let title = "";
            //       let search_type = item.search_type;
            //       switch (search_type) {
            //         case "新闻":
            //           title = item.title;
            //           break;
            //         case "微博":
            //           title = item.author;
            //           break;
            //         case "公众号":
            //           title = item.title;
            //           break;
            //         case "贴吧":
            //           title = `[${item.bar_name}吧] ${item.title}`;
            //           break;
            //         default:
            //           title = item.title;
            //           break;
            //       }
            //       return title;
            //     })(item),
            //     sourceUrl: item.sourceUrl,
            //     content:
            //       item.outline.length > 80
            //         ? item.outline.substring(0, 80) + "..."
            //         : item.outline,
            //     origin: item.source_name,
            //     isWarn: item.isWarn,
            //     date: this.formatDate(parseInt(item.publishTime)),
            //     time: this.formatTime(parseInt(item.publishTime)),
            //     keywords: item.search_words,
            //     frequency: (function(keyword_match) {
            //       let frequency = "";
            //       //先删除所有count为0的数组
            //       keyword_match = keyword_match.filter(item => {
            //         return item.count > 0;
            //       });
            //       //然后对剩余数组进行排序
            //       let arr_frequency = keyword_match
            //         .sort((a, b) => b.count - a.count)
            //         .slice(0, 2);
            //       if (arr_frequency.length === 2) {
            //         frequency = `${arr_frequency[0].keyword}(${arr_frequency[0].count})&nbsp;&nbsp;${arr_frequency[1].keyword}(${arr_frequency[1].count})`;
            //       } else if (arr_frequency.length === 1) {
            //         frequency = `${keyword_match[0].keyword}(${keyword_match[0].count})`;
            //       }
            //       return frequency;
            //     })(item.keyword_match ? item.keyword_match : []),
            //     articleNum: item.similarTxtNum || 0,
            //     followers_num: item.followers_num || 0,
            //     comment_num: item.comment_num || 0,
            //     like_num: item.like_num || 0,
            //     forward_num: item.forward_num || 0,
            //     author: item.author,
            //     source_name: item.search_type,
            //     floor_count: item.floor_count || 0,
            //     urlid : item.urlid || '',
            //     update_time : item.update_time ||'',
            //     search_type: item.search_type,
            //   });
            // });
            //更新刷新列表数据时间
            this.lastRefreshTime = new Date().getTime();
            //销毁之前的tip定时器
            clearInterval(this.timer);
            this.timer = null;
            //重新开始tip定时器
            this.openTipTimer();
          } else {
            if (res.data.code !== 405) {
              //this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          //this.$Message.error("服务器错误");
          this.isLoading_listMessage = false;
          console.log(err);
        });
    },
    //根据过滤条件获取快速分析模块的数据(词云分析除外)
    getRapidAnalyseInfo() {
      if (this.isLoading_rapidAnalyse) return;
      this.isLoading_rapidAnalyse = true;
      //jobId不能为空
      if (this.queryData.jobId === "") {
        this.isLoading_rapidAnalyse = false;
        return;
      }
      this.$ajax({
        method: "get",
        url: "./sentiment/longTxtData/analyze",
        params: this.queryData
      })
        .then(res => {
          this.isLoading_rapidAnalyse = false;
          if (res.data.success) {
            let resData = res.data.data;
            //更新舆情走势x轴数据
            this.sentimentTrendData.xData = resData.trends.dateList;
            //更新舆情走势--<全部>数据
            this.sentimentTrendData.charts_all = resData.trends.totalTrends;
            //生成<全部>折线图
            this.generateCharts_line_all();

            //更新<来源分类>折线图数据
            this.sentimentTrendData.charts_source.data_legend = [];
            this.sentimentTrendData.charts_source.data_y = [];
            for (let prop in resData.trends.sourceTrends) {
              this.sentimentTrendData.charts_source.data_legend.push(prop);
              this.sentimentTrendData.charts_source.data_y.push({
                name: prop,
                type: "line",
                data: [...resData.trends.sourceTrends[prop]],
                smooth: true
              });
            }
            //生成<来源分类>折线图
            this.generateCharts_line_source();

            //更新<情感分类>折线图数据
            this.sentimentTrendData.charts_emotion.data_legend = [];
            this.sentimentTrendData.charts_emotion.data_y = [];
            for (let prop in resData.trends.emotionTrends) {
              this.sentimentTrendData.charts_emotion.data_legend.push(prop);
              this.sentimentTrendData.charts_emotion.data_y.push({
                name: prop,
                type: "line",
                smooth: true,
                itemStyle: {
                  normal: {
                    color: (function(prop) {
                      let color = "#44C58D";
                      switch (prop) {
                        case "正面":
                          color = "#44C58D";
                          break;
                        case "负面":
                          color = "#FA5D5D";
                          break;
                        case "中性":
                          color = "#FFA810";
                          break;
                        default:
                          break;
                      }
                      return color;
                    })(prop),
                    lineStyle: {
                      color: (function(prop) {
                        let color = "#44C58D";
                        switch (prop) {
                          case "正面":
                            color = "#44C58D";
                            break;
                          case "负面":
                            color = "#FA5D5D";
                            break;
                          case "中性":
                            color = "#FFA810";
                            break;
                          default:
                            break;
                        }
                        return color;
                      })(prop)
                    }
                  }
                },
                data: resData.trends.emotionTrends[prop]
              });
            }
            //生成<情感分类>折线图
            this.generateCharts_line_emotions();

            //更新<情感分布>空心饼图数据
            this.emotionsDistrubutionData = [];
            for (let i = 0; i < resData.emotions.length; i++) {
              this.emotionsDistrubutionData.push({
                value: resData.emotions[i].value,
                name: resData.emotions[i].name,
                itemStyle: {
                  normal: {
                    color: (function(name) {
                      let color = "#44C58D";
                      switch (name) {
                        case "正面":
                          color = "#44C58D";
                          break;
                        case "负面":
                          color = "#FA5D5D";
                          break;
                        case "中性":
                          color = "#FFA810";
                          break;
                        default:
                          break;
                      }
                      return color;
                    })(resData.emotions[i].name),
                    lineStyle: {
                      color: (function(name) {
                        let color = "#44C58D";
                        switch (name) {
                          case "正面":
                            color = "#44C58D";
                            break;
                          case "负面":
                            color = "#FA5D5D";
                            break;
                          case "中性":
                            color = "#FFA810";
                            break;
                          default:
                            break;
                        }
                        return color;
                      })(resData.emotions[i].name)
                    }
                  }
                }
              });
            }
            //生成情感分布空心饼图
            this.generateCharts_circle();

            //更新<媒体预警排行量>表格数据
            this.table_mediaSpecData = [];
            for (let i = 0; i < resData.mediaWarns.length; i++) {
              this.table_mediaSpecData.push({
                id: i,
                name: resData.mediaWarns[i].name,
                alertAmount: resData.mediaWarns[i].warningCount,
                total: resData.mediaWarns[i].totalCount,
                alertRatio: resData.mediaWarns[i].percent + "%"
              });
            }
          } else {
            if (res.data.code !== 405) {
              //this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          //this.$Message.error("服务器错误");
          this.isLoading_rapidAnalyse = false;
          console.log(err);
        });
    },
    //根据过滤条件获取快速分析模块的数据--词云
    getRapidAnalyseInfo_wordCloud() {
      if (this.isLoading_rapidAnalyse_wordCloud) return;
      this.isLoading_rapidAnalyse_wordCloud = true;
      //jobId不能为空
      if (this.queryData.jobId === "") {
        this.isLoading_rapidAnalyse_wordCloud = false;
        return;
      }
      let queryWordCloud = {
        jobId: this.queryData.jobId,
        startTime: this.queryData.startTimeMs,
        endTime: this.queryData.endTimeMs,
        sourceName: this.queryData.sourceType,
        showType: 2, //数据类型，默认为0, 0：所有，1：群组，2：媒体
        count: 20, //词云展示数量，默认20
        keyWords: this.queryData.searchWord, //关键词搜索条件，多个以逗号隔开（快速分析界面使用）
        feeling: this.queryData.feeling == 3 ? "" : this.queryData.feeling, //0:中性 1:负面 2:正面 3:全部（快速分析界面使用）
        repeat: this.queryData.isRepeat, //0:去重，1不去重（快速分析界面使用）
        classify: this.queryData.customClassifyName, //自定义分类名称（快速分析界面使用）
        isWarn: this.queryData.isWarn
      };
      this.$ajax({
        method: "get",
        url: "./summary/keyword/result",
        params: queryWordCloud
      })
        .then(res => {
          this.isLoading_rapidAnalyse_wordCloud = false;
          if (res.data.success) {
            this.wordCloudData = [];
            let resData = res.data.data || [];
            resData.forEach(item => {
              this.wordCloudData.push({
                name: item.keyword,
                value: item.num,
                prop: item.feeling,
                textStyle: this.generateColor(parseInt(item.feeling))
              });
            });
            //生成词云图
            this.generateCharts_wordCloud();
          } else {
            if (res.data.code !== 405) {
              //this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          //this.$Message.error("服务器错误");
          this.isLoading_rapidAnalyse_wordCloud = false;
          console.log(err);
        });
    },
    //改变过滤tab栏的样式
    getMessageListInfoAfterFilter() {
      //先还原页码
      this.currentPage = this.queryData.pageNum = 1;
      //根据当前条件查询舆情列表数据
      this.getMessageListInfo();
      //根据当前查询条件查询快速分析模块数据(词云分析除外)
      this.getRapidAnalyseInfo();
      //根据当前查询条件查询快速分析模块数据--词云
      this.getRapidAnalyseInfo_wordCloud();
    },
    //初始化页码和过滤按钮
    initAll() {
      //发布时间样式还原
      $(".btn-item-1d")
        .addClass("btn-active")
        .siblings("li")
        .removeClass("btn-active");
      //关键词搜索框
      this.search_keywords = "";
      //初始化来源分类按钮数量
      this.sourceNum.all = this.sourceNum.news = this.sourceNum.weibo = this.sourceNum.public = 0;
      //初始化<相似文章>按钮和<不去重>按钮的可点击性
      this.isSimilarArticlesClickable = this.isRepeatClickable = true;
      //初始化查询数据
      this.queryData.startTimeMs = new Date().setHours(0, 0, 0, 0);
      this.queryData.endTimeMs = new Date().getTime();
      this.queryData.feeling = 3;
      this.queryData.sourceType = "";
      this.queryData.customClassifyName = "";
      this.queryData.sortType = "desc";
      this.queryData.isRepeat = 0;
      // this.queryData.isRepeat = 1;
      this.queryData.searchWord = "";
      this.queryData.pageNum = 1;
      this.queryData.pageSize = 10;
      //初始化页码
      this.currentPage = 1;
      //隐藏datePicker
      this.isShowDatePicker = false;
      //页面回滚到最顶部
      window.scrollTo(0, 0);
      //清除吸顶效果
      this.isTabHeaderStick = false;
    },
    //点击<发布时间>tab
    handleSelectLanchDate(prop) {
      this.isShowDatePicker = false;
      if (prop === "1d") {
        this.queryData.startTimeMs = new Date().setHours(0, 0, 0, 0); //起始时间是今天0点
      } else {
        //如果不是<今天>，则倒推到(n-1)天前的0点，例如今天是15日，近3天的起始时间是13日的0点
        this.queryData.startTimeMs =
          new Date().setHours(0, 0, 0, 0) -
          1000 * 60 * 60 * 24 * (parseInt(prop) - 1);
      }
      this.queryData.endTimeMs = new Date().getTime();
      this.getMessageListInfoAfterFilter();
      //改变相应tab按钮样式
      $(".btn-item-" + prop)
        .addClass("btn-active")
        .siblings("li")
        .removeClass("btn-active");
    },
    //点击<发布时间--自定义>tab
    setLanchDateByCustom(prop) {
      this.isShowDatePicker = true;
      $(".btn-item-" + prop)
        .addClass("btn-active")
        .siblings("li")
        .removeClass("btn-active");
    },
    //点击<情感分类>tab
    handleSelectSentiment(prop) {
      if(this.queryData.sourceType == '投诉' && (prop == 2 || prop == 0)){return}   //投诉信息没有情感分类 全部为负面
      this.queryData.feeling = prop;
      this.getMessageListInfoAfterFilter();
    },
    //点击<来源分类>tab
    /*handleSelectOrigin(prop) {
      switch (prop) {
        case "allOrigin":
          this.queryData.sourceType = "";
          break;
        case "news":
          this.queryData.sourceType = "新闻";
          break;
        case "weibo":
          this.queryData.sourceType = "微博";
          break;
        case "pubilcAccount":
          this.queryData.sourceType = "公众号";
          break;
        case "tieba":
          this.queryData.sourceType = "贴吧";
          break;
        case "tousu":
          this.queryData.sourceType = "投诉";
          if(this.queryData.sortType == 'similar'){
            this.queryData.sortType = 'desc'
          }
          if(this.queryData.feeling == 0 || this.queryData.feeling == 2){
            this.queryData.feeling = 3
          }
          break;
      }
      this.getMessageListInfoAfterFilter();
    },*/
    //点击<来源分类>tab 多选
    handleSelectOrigin(prop){
      let propTypeList = ["allOrigin", "news", "weibo", "pubilcAccount", "tieba"];
      console.log(prop)
      if (prop == 'allOrigin') {
        this.queryData.sourceType = "";
      } else if (prop == '投诉') {
          this.queryData.sourceType = "投诉";
          if(this.queryData.sortType == 'similar'){
            this.queryData.sortType = 'desc'
          }
          if(this.queryData.feeling == 0 || this.queryData.feeling == 2){
            this.queryData.feeling = 3
          }
      } else {
          let items = this.queryData.sourceType.split(",");
          let indexItem = items.indexOf(prop);
          if (indexItem == -1) {
            items.push(prop)
          } else {
            delete(items[indexItem]);
          }
          items = items.filter(Boolean);
          this.queryData.sourceType = items.join(",")
      }
      this.getMessageListInfoAfterFilter();
    },
    //点击<自定义分类>tab
    /*handleSelectCustom(prop) {
      this.queryData.customClassifyName = prop;
      this.getMessageListInfoAfterFilter();
    },*/
    //点击<自定义分类>tab 多选
    handleSelectCustom(prop) {
      if (prop == '') {
        this.queryData.customClassifyName = "";
        this.customClassifyNameList = [];
      } else {
        let items = this.queryData.customClassifyName.split(",");
        let indexItem = items.indexOf(prop);
        if (indexItem == -1) {
          items.push(prop)
        } else {
          delete(items[indexItem]);
        }
        items = items.filter(Boolean);
        this.customClassifyNameList = items;
        this.queryData.customClassifyName = items.join(",")
      }
      this.getMessageListInfoAfterFilter();
    },
    //点击<排序方式>tab
    handleSelectSort(prop) {
      if (prop === "similar" && (!this.isSimilarArticlesClickable || this.queryData.sourceType == '投诉')) return;
      this.queryData.sortType = prop;
      switch (prop) {
        case "desc":
          this.isRepeatClickable = true;
          break;
        case "asc":
          this.isRepeatClickable = true;
          break;
        case "similar":
          this.isRepeatClickable = false;
          break;
        default:
          break;
      }
      this.getMessageListInfoAfterFilter();
    },
    // 切换预警展示
    handleSelectIsWarn(params) {
      this.queryData.isWarn = params;
      this.getMessageListInfoAfterFilter();
    },
    //点击<相似文章>tab
    handleSelectArticle(prop) {
      if(this.queryData.sourceType == '投诉') return;
      if (prop === 1 && !this.isRepeatClickable) return;
      this.queryData.isRepeat = prop;
      this.isSimilarArticlesClickable = prop === 0 ? true : false;
      this.isRepeat = prop === 0 ? true : false;
      this.getMessageListInfoAfterFilter();
    },
    // 点击去除关键词
    handleExcludeWords() {
      if (this.queryData.isExcludeWord == false) {
        this.queryData.isExcludeWord = true;
      } else {
        this.queryData.isExcludeWord = false;
      }
      this.getMessageListInfoAfterFilter();
    },
    //进行关键词搜索
    searchByKeywords() {
      this.queryData.searchWord = this.search_keywords.trim();
      this.currentPage = this.queryData.pageNum = 1;
      this.getMessageListInfo();
      this.getRapidAnalyseInfo();
      this.getRapidAnalyseInfo_wordCloud();
    },
    //翻页
    changePage(page) {
      //更新页码
      this.currentPage = this.queryData.pageNum = page;
      //查询舆情列表数据
      this.getMessageListInfo();
    },
    //点击dataPicker的<确认>按钮
    confirmDatePicker() {
      //校验当前日期范围跨度是否大于90天
      let start = this.dateRange[0];
      let end = this.dateRange[1];
      let differ =
        (this.dateRange[1].getTime() - this.dateRange[0].getTime()) /
          (1000 * 60 * 60 * 24) +
        1;
      if (differ > 90) {
        this.$Message.error("日期范围跨度不得大于90天");
        this.dateRange = []; //清空已选日期
      } else {
        //更新消息列表数据
        if (this.dateRange[0] === this.dateRange[1]) {
          //如果选中的起止日期是同一天
          this.queryData.startTimeMs = this.dateRange[0].getTime();
          this.queryData.endTimeMs =
            this.dateRange[0].getTime() + 1000 * 60 * 60 * 24 - 1;
        } else {
          //如果起止日期不是同一天
          this.queryData.startTimeMs = this.dateRange[0].setHours(0, 0, 0, 0);
          this.queryData.endTimeMs =
            this.dateRange[1].setHours(0, 0, 0, 0) + 1000 * 60 * 60 * 24 - 1;
        }
        this.currentPage = this.queryData.pageNum = 1;
        //进行数据查询
        this.getMessageListInfo();
        this.getRapidAnalyseInfo();
        this.getRapidAnalyseInfo_wordCloud();
      }
    },
    //点击舆情列表信息跳转到相应媒体页面
    gotoSource(url,id,time,item) {
      // console.log(item)
      if(item.search_type == '公众号'){
        // console.log('公众号')
        let date = new Date();
        let nowTime = date.getTime();
        if(nowTime - parseInt(time) > 6*60*60*1000){
          // console.log('时间超过')
          // this.$router.resolve({
          //   path:'./sentiment/wechat',
          //   query: {
          //     id:id
          //   }
          // })
          window.open('./wechat?id=' + id)
        }else{
          window.open(url);
        }
      }else{
        window.open(url);
      }
      
    },
    //点击<相似文章>
    checkSimilarArticle(param) {
      //param===[[item.uniqueId,item.id,item.articleNum]]
      //如果文章数目为0，则不可以点击
      if (param[2] === 0) return;
      let routeData = this.$router.resolve({
        path: "/mediaSpec_similarArticle",
        query: {
          jobId: this.currentTaskId,
          uniqueId: param[0],
          id: param[1],
          startTimeMs: this.queryData.startTimeMs,
          endTimeMs: this.queryData.endTimeMs,
          sourceType:
            this.queryData.sourceType === ""
              ? "新闻"
              : this.queryData.sourceType
        }
      });
      window.open(routeData.href, "_blank");
    },
    //开启tip定时器，每五分钟获取一次新数据
    openTipTimer() {
      this.timer = setInterval(() => {
        this.refreshTipInfo();
      }, 1000 * 60 * 5);
    },
    //获取tip的新数据
    refreshTipInfo() {
      if (this.isLoading_tipInfo) return;
      this.isLoading_tipInfo = true;
      //jobId不能为空
      if (this.queryData.jobId === "") {
        this.isLoading_tipInfo = false;
        return;
      }
      let tipQueryData = Object.assign({}, this.queryData);
      tipQueryData.startTimeMs = this.lastRefreshTime;
      tipQueryData.endTimeMs = new Date().getTime();

      this.$ajax({
        method: "get",
        url: "./sentiment/longTxtData/longTxtsList",
        params: tipQueryData
      })
        .then(res => {
          this.isLoading_tipInfo = false;
          if (res.data.success) {
            let resData = res.data.data;
            this.tip.currentDate = this.formatDate(this.lastRefreshTime);
            this.tip.currentTime = this.formatTime(this.lastRefreshTime);
            this.tip.newDataNum = resData.total;
            //如果从未显示过tip，那么直到抓取到新数据时才显示tip，否则不显示
            if (!this.isShowTip) {
              if (this.tip.newDataNum !== 0) {
                this.isShowTip = true;
              }
            }
          } else {
            if (res.data.code !== 405) {
              //this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          //this.$Message.error("服务器错误");
          this.isLoading_tipInfo = false;
          console.log(err);
        });
    },
    //点击tip刷新数据
    handleClickTip() {
      this.isShowTip = false;
      this.getMessageListInfo(true);
      this.getRapidAnalyseInfo();
      this.getRapidAnalyseInfo_wordCloud();
    },
    //快速分析模块------------------------------------------------------------------//
    handleSelectBtnTrend(params) {
      this.btnTrendIsActive.all = this.btnTrendIsActive.source = this.btnTrendIsActive.emotions = false;
      this.btnTrendIsActive[params] = true;
    },
    //点击<舆情走势图表>的下载按钮
    downLoadTrendPic() {
      if (this.isBtnDownloadDisabled_trend) return;
      let url = "";
      let picTitle = "";
      if (this.btnTrendIsActive.all) {
        picTitle = "舆情走势(全部).png";
        url = this.echartsDataUrl.url_trend_all;
      } else if (this.btnTrendIsActive.source) {
        picTitle = "舆情走势(来源分类).png";
        url = this.echartsDataUrl.url_trend_source;
      } else if (this.btnTrendIsActive.emotions) {
        picTitle = "舆情走势(情感分类).png";
        url = this.echartsDataUrl.url_trend_emotions;
      }
      let a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("download", picTitle);
      a.click();
    },
    //点击<情感分布>下载按钮
    downLoadEmotionsPic() {
      if (this.isBtnDownloadDisabled_emotions) return;
      let a = document.createElement("a");
      a.setAttribute("href", this.echartsDataUrl.url_emotions);
      a.setAttribute("download", "情感分布.png");
      a.click();
    },
    //点击<词云分析>的下载按钮
    downLoadWordCloudPic() {
      if (this.isBtnDownloadDisabled_wordCloud) return;
      let a = document.createElement("a");
      a.setAttribute("href", this.echartsDataUrl.url_wordCloud);
      a.setAttribute("download", "词云分析.png");
      a.click();
    },
    //生成<舆情走势>折线图--全部
    generateCharts_line_all() {
      this.isBtnDownloadDisabled_trend = true;
      let myChart = this.echarts.init(this.$refs.charts_line_total);
      let option = {
        xAxis: {
          type: "category",
          data: this.sentimentTrendData.xData //x轴数据
        },
        yAxis: {
          type: "value"
        },
        grid: {
          top: "2%",
          left: "1%",
          right: "1%",
          bottom: "1%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        series: [
          {
            name: "全部",
            data: this.sentimentTrendData.charts_all,
            itemStyle: {
              normal: {
                color: "#4CB6FF",
                lineStyle: {
                  color: "#4CB6FF"
                }
              }
            },
            smooth: true,
            type: "line"
          }
        ]
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        this.echartsDataUrl.url_trend_all = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff"
        });
        this.isBtnDownloadDisabled_trend = false;
      }, 2000);
    },
    //生成折线图--来源分类
    generateCharts_line_source() {
      this.isBtnDownloadDisabled_trend = true;
      let myChart = this.echarts.init(this.$refs.charts_line_source);
      let option = {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: this.sentimentTrendData.charts_source.data_legend, //所有来源的legend名称
          y: "360px"
        },
        grid: {
          top: "6%",
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.sentimentTrendData.xData //x轴数据
        },
        yAxis: {
          type: "value"
        },
        series: this.sentimentTrendData.charts_source.data_y
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        this.echartsDataUrl.url_trend_source = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff"
        });
        this.isBtnDownloadDisabled_trend = false;
      }, 2000);
    },
    //生成折线图--情感分类
    generateCharts_line_emotions() {
      this.isBtnDownloadDisabled_trend = true;
      let myChart = this.echarts.init(this.$refs.charts_line_emotions);
      let option = {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: this.sentimentTrendData.charts_emotion.data_legend, //所有来源的legend名称
          y: "360px"
        },
        grid: {
          top: "6%",
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.sentimentTrendData.xData //x轴数据
        },
        yAxis: {
          type: "value"
        },
        series: this.sentimentTrendData.charts_emotion.data_y
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        this.echartsDataUrl.url_trend_emotions = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff"
        });
        this.isBtnDownloadDisabled_trend = false;
      }, 2000);
    },
    //生成空心饼图
    generateCharts_circle() {
      this.isBtnDownloadDisabled_emotions = true;
      let myChart = this.echarts.init(this.$refs.charts_circle);
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        grid: {
          left: "7%",
          right: "7%",
          bottom: "7%",
          top: "7%",
          containLabel: true
        },
        series: [
          {
            name: "情感分布",
            type: "pie",
            radius: ["50%", "65%"],
            label: {
              normal: {
                formatter: "{b}\n({d}%) ",
                textStyle: {
                  fontWeight: "normal",
                  fontSize: "15" //文字的字体大小
                }
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "20",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: true
              }
            },
            data: this.emotionsDistrubutionData
          }
        ]
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        this.echartsDataUrl.url_emotions = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff"
        });
        this.isBtnDownloadDisabled_emotions = false;
      }, 2000);
    },
    //生成词云
    generateCharts_wordCloud() {
      this.isBtnDownloadDisabled_wordCloud = true;
      let myChart = this.echarts.init(this.$refs.charts_wordCloud);
      let option = {
        tooltip: {
          show: true
        },
        series: [
          {
            name: "词云分析",
            type: "wordCloud",
            size: ["80%", "80%"],
            sizeRange: [25, 100],
            rotationRange: [0, 0],
            textPadding: 0,
            autoSize: {
              enable: true,
              minSize: 14
            },
            data: this.wordCloudData
          }
        ]
      };

      myChart.setOption(option, true);
      setTimeout(() => {
        this.echartsDataUrl.url_wordCloud = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff"
        });
        this.isBtnDownloadDisabled_wordCloud = false;
      }, 2000);
    },
    //根据词云的情感生成颜色
    generateColor(prop) {
      let obj = {
        normal: {
          color: ""
        }
      };
      switch (prop) {
        //正面
        case 2:
          obj.normal.color = "#44C58D";
          break;
        //中性
        case 0:
          obj.normal.color = "#FFA810";
          break;
        //负面
        case 1:
          obj.normal.color = "#FA5D5D";
          break;
        default:
          break;
      }
      return obj;
    }
  }
};
</script>

<style lang="less">
@import "../../../style/common.less";
.hover-text{
  position: fixed;
  padding: 0 5px;
  background-color: #fff;
  font-size: 12px;
  color:#333333;
  border: 1px solid #C4C3D0;
  border-radius: 3px;
}
.btn-disabled {
  color: #ccc !important;
  cursor: not-allowed !important;
}
#page-mediaSpec {
  ul {
    list-style-type: none;
  }
  .main {
    width: 1160px;
    margin: 20px auto !important;
    #rightSide {
      min-height: 1000px;
      .content-up {
        background-color: #fff;
        padding: 30px 20px;
        width: 944px;
        .option-title {
          line-height: 35px;
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #666666;
          letter-spacing: -0.33px;
          margin-right: 25px;
        }
        .btn-item {
          float: left;
          line-height: 38px;
          border: 1px solid #ddd;
          border-right: none;
          height: 40px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #333333;
          letter-spacing: -0.29px;
          cursor: pointer;
          transition: all 0.2s ease-in-out;
          user-select: none;
        }
        
        .btn-item:first-child {
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
        }
        .btn-item:last-child {
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
          border-right: 1px solid #ddd;
        }
        .btn-active {
          background-color: #415af6;
          border: none;
          color: #fff;
        }
        //发布时间----------------------------//
        .buttonGroup-date {
          .btn-item {
            width: 103px;
          }
          .btn-item:first-child {
            width: 96px;
          }
        }
        //情感分类----------------------------//
        .buttonGroup-sentiment {
          .btn-item {
            width: 95px;
          }
          .btn-item:first-child {
            width: 96px;
          }
        }
        //来源分类----------------------------//
        .buttonGroup-origin {
          .btn-item {
            width: 95px;
          }
          .btn-item:first-child {
            width: 96px;
          }
        }
        //自定义分类----------------------------//
        .buttonGroup-custom {
          .btn-item {
            width: 96px;
          }
          .btn-item:first-child {
            width: 96px;
          }
        }
        //排序方式----------------------------//
        .buttonGroup-sort {
          .btn-item {
            width: 127px;
          }
        }
        //相似文章----------------------------//
        .buttonGroup-article {
          .btn-item {
            width: 103px;
          }
        }
        .input-search {
          float: left;
          input {
            font-size: 14px;
            color: #333333;
            height: 35px;
          }
        }
      }
      .content-down {
        background-color: #fff;
        margin-top: 16px;
        padding: 0 23px 50px 23px;
        width: 944px;
        box-sizing: border-box;
        .tab-header {
          height: 59px;
          border-bottom: 1px solid #efeff4;
          position: relative;
          .tab-title {
            float: left;
            width: 75px;
            height: 60px;
            line-height: 60px;
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #333333;
            margin-right: 64px;
            cursor: pointer;
            &.tab-title-selected{
              border-bottom: 3px solid #415af6;
            }
            &.disabled{
              color: #999;
              cursor: not-allowed;
            }
          }
          .dataNum-wrapper {
            position: absolute;
            right: 0;
            padding: 18px 0;
            overflow: hidden;
            height: 100%;
            box-sizing: border-box;
            margin-right: 23px;
            .tag-dataNum {
              float: left;
              margin-left: 20px;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #ffffff;
            }
          }
        }
        .tab-header-stick {
          position: fixed;
          top: 0;
          height: 59px;
          width: 898px;
          background-color: #fff;
          z-index: 999;
        }
        .tab-header-placeholder {
          position: fixed;
          height: 0;
          width: 0;
        }
        .tab-header-placeholder-active {
          position: static;
          height: 59px;
          width: 898px;
          opacity: 1;
        }

        // 舆情列表-------------------------------------------------------//
        .tab-main-msgList {
          .tab-content {
            .tip {
              margin: 20px 0 10px 0;
              p {
                padding-left: 5px;
                height: 30px;
                line-height: 30px;
                text-align: left;
                background-color: #fffcdd;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #ffa810;
                cursor: pointer;
              }
              p:hover {
                opacity: 0.8;
              }
            }
            .listMessage-wrapper {
              margin-top: 20px;
              .listMessage {
                .listMessage-item {
                  overflow: hidden;
                  margin-bottom: 30px;
                  .ls {
                    float: left;
                  }
                  .rs {
                    float: left;
                    width: 800px;
                    padding-left: 15px;
                    .rs-main {
                      cursor: pointer;
                      .message-title {
                        text-align: left;
                        .message-link-toSpecGroup {
                          display: inline-block;
                          border-bottom: 2px solid #fff;
                          cursor: pointer;
                          box-sizing: border-box;
                          .groupMemberName {
                            font-family: PingFangSC-Medium;
                            font-size: 16px;
                            color: #415af6;
                            letter-spacing: 0;
                            line-height: 24px;
                          }
                          .groupNum {
                            font-family: PingFangSC-Medium;
                            font-size: 16px;
                            color: #415af6;
                            letter-spacing: 0;
                            line-height: 24px;
                            margin-left: 15px;
                          }
                        }
                        .message-link-toSpecGroup:hover {
                          box-sizing: border-box;
                          border-bottom: 2px solid #fff;
                        }
                        .icon-warning {
                          display: inline-block;
                          height: 24px;
                          width: 26px;
                          margin-left: 10px;
                          background: url("https://static.rong360.com/upload/png/b4/4f/b44f799a6e4df113a1647d0d9d4d7a18.png");
                          .pic;
                          vertical-align: top;
                        }
                        .messageLanchTime {
                          float: right;
                          font-family: PingFangSC-Regular;
                          font-size: 12px;
                          color: #c8c7cc;
                          letter-spacing: 0;
                        }
                      }
                      .message-content {
                        margin-top: 8px;
                        font-family: PingFangSC-Regular;
                        font-size: 14px;
                        color: #666666;
                        letter-spacing: 0;
                        text-align: left;
                        line-height: 22px;
                      }
                    }
                    .message-footer{
                      overflow: hidden;
                      margin-top: 15px;
                      .message-footer-ls{
                        float: left;
                        text-align: left;
                        display: flex;
                        justify-content: space-between;
                      }
                      .footer-item{
                        font-family: PingFangSC-Regular;
                        font-size: 12px;
                        color: #999999;
                        letter-spacing: 0;
                        line-height: 22px;
                        span {
                          color: #333333;
                        }
                      }
                      .message-footer-rs{
                        float: right;
                        width: 110px;
                        .similarArticle {
                          font-family: PingFangSC-Regular;
                          font-size: 12px;
                          color: #415af6;
                          letter-spacing: 0;
                          text-align: right;
                          cursor: pointer;
                          float: right;
                        }
                      }
                    }
                    .message-footer-news,.message-footer-pubilc {
                      .message-footer-ls {
                        width: 675px;
                        .footer-item{
                          width: 225px;
                        }
                      }
                    }
                    .message-footer-weibo {
                      .message-footer-ls {
                        width: 57%;
                        .footer-item{
                          flex: 1 0 0%;
                        }
                      }
                    }
                    .message-footer-tieba {
                      width: 50%;
                      display: flex;
                      justify-content: space-between;
                      .footer-item{
                        flex: 1 0 225px;
                        text-align: left;
                      }
                    }
                    .message-footer-tousu{
                      display: flex;
                      .footer-item{
                        text-align: left;
                        margin-right: 5px;
                        // width:200px ;
                        flex: 2;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        &.rele{
                          flex: 1;
                          margin-right: 0;
                          // width: 140px;
                        }
                      }
                    } 
                  }
                }
              }
            }
          }
          .page-wrapper {
            margin-top: 40px;
            .page;
          }
        }

        // 快速分析-------------------------------------------------------//
        .tab-main-rapidAnalyse {
          .tip {
            margin: 20px 0 10px 0;
            p {
              padding-left: 5px;
              height: 30px;
              line-height: 30px;
              text-align: left;
              background-color: #fffcdd;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #ffa810;
              cursor: pointer;
            }
            p:hover {
              opacity: 0.8;
            }
          }
          .section-title {
            text-align: left;
            font-family: PingFangSC-Medium;
            font-size: 24px;
            color: #333333;
            letter-spacing: 0;
          }
          .icon-download {
            width: 66px;
            height: 22px;
            line-height: 22px;
            border: 1px solid #415af6;
            color: #415af6;
            border-radius: 11px;
            position: absolute;
            text-align: right;
            padding-right: 12px;
            top: 5px;
            right: 0;
            cursor: pointer;
            &::before {
              content: "";
              position: absolute;
              top: 50%;
              left: 12px;
              transform: translate(0, -50%);
              display: inline-block;
              background: url("https://static.rong360.com/upload/png/95/75/95756aa6fad3be38a4101f5ae0c3dee7.png");
              height: 14px;
              width: 10px;
              .pic;
            }
            &:hover {
              opacity: 0.8;
            }
          }
          .wrap-up {
            height: 484px;
            width: 895px;
            margin-top: 30px;
            display: flex;
            justify-content: space-between;
            .wrap-trendCharts {
              height: 484px;
              width: 431px;
              position: relative;
              .btnGroup {
                margin-top: 35px;
                width: 240px;
                height: 22px;
                cursor: pointer;
                user-select: none;
                .btnItem {
                  width: 80px;
                  color: #415af6;
                  font-family: PingFangSC-Regular;
                  font-size: 14px;
                  height: 22px;
                  line-height: 22px;
                  border: 1px solid #415af6;
                  border-left: none;
                  float: left;
                  transition: all 0.2s ease-in-out;
                  &:hover {
                    opacity: 0.8;
                  }
                }
                .btnItem:first-child {
                  border-left: 1px solid #415af6;
                  // border-radius: 3px 0 0 3px;
                  border-top-left-radius: 3px;
                  border-bottom-left-radius: 3px;
                }
                .btnItem:last-child {
                  // border-radius: 0 3px 3px 0;
                  border-top-right-radius: 3px;
                  border-bottom-right-radius: 3px;
                }
                .isSelected {
                  background-color: #415af6;
                  color: #fff;
                }
              }
              .charts-wrapper {
                height: 385px;
                width: 431px;
                .charts_line_total,
                .charts_line_source,
                .charts_line_emotions {
                  height: 385px;
                  width: 431px;
                }
                .charts_line_total {
                  margin-top: 20px;
                }
              }
            }
            .wrap-mediaSpecTable {
              height: 484px;
              width: 431px;
              position: relative;
            }
            .table;
          }
          .wrap-down {
            margin-top: 56px;
            height: 502px;
            width: 895px;
            display: flex;
            justify-content: space-between;
            .section-title {
              margin-bottom: 33px;
            }
            .wrap-emotionsDistribution {
              height: 484px;
              width: 426px;
              position: relative;
              .charts-wrapper {
                border: 1px solid #d8d8d8;
                .charts_circle {
                  height: 421px;
                  width: 426px;
                }
              }
            }
            .charts-wrapper {
              width: 426px;
              height: 421px;
              border: 1px solid #ddd;
            }
            .wrap-wordCloudCharts {
              height: 484px;
              width: 426px;
              position: relative;
              .charts_wordCloud {
                height: 400px;
                width: 426px;
              }
              .wordCloud-footer {
                position: absolute;
                bottom: 0;
                height: 80px;
                width: 100%;
                display: flex;
                justify-content: center;
                .wordCloud-legend {
                  font-family: PingFangSC-Regular;
                  font-size: 12px;
                  color: #666666;
                  line-height: 80px;
                }
                .legend-positive {
                  &::before {
                    content: "";
                    display: inline-block;
                    height: 10px;
                    width: 10px;
                    border-radius: 50%;
                    background-color: #44c58d;
                    margin-right: 6px;
                  }
                }
                .legend-middle {
                  margin: 0 30px;
                  &::before {
                    content: "";
                    display: inline-block;
                    height: 10px;
                    width: 10px;
                    border-radius: 50%;
                    background-color: #ffa810;
                    margin-right: 6px;
                  }
                }
                .legend-negative {
                  &::before {
                    content: "";
                    display: inline-block;
                    height: 10px;
                    width: 10px;
                    border-radius: 50%;
                    background-color: #fa5d5d;
                    margin-right: 6px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
